var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup9219(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9219",
    "data-name": "Group 9219",
    transform: "translate(-162 -95)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(162 95)",
    fill: "#00ca7d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pricing",
    transform: "translate(169.001 92.501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57777",
    "data-name": "Path 57777",
    d: "M13.83,26H4.578A.578.578,0,0,0,4,26.578v13.3a.578.578,0,0,0,.578.578H13.83a.578.578,0,0,0,.578-.578v-13.3A.578.578,0,0,0,13.83,26Zm-.578,13.3H5.156V27.156h8.095Z",
    transform: "translate(-2.001 -10.612)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57779",
    "data-name": "Path 57779",
    d: "M32.83,21H23.578a.578.578,0,0,0-.578.578V40.659a.578.578,0,0,0,.578.578H32.83a.578.578,0,0,0,.578-.578V21.578A.578.578,0,0,0,32.83,21Zm-.578,19.081H24.156V22.156h8.095Z",
    transform: "translate(-10.016 -8.501)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57782",
    "data-name": "Path 57782",
    d: "M8.578,31.156h2.313a.578.578,0,0,0,0-1.156H8.578a.578.578,0,1,0,0,1.156Z",
    transform: "translate(-3.687 -12.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57783",
    "data-name": "Path 57783",
    d: "M15,30.734a.578.578,0,0,0,.578.578h.578a.572.572,0,0,0,.2-.041l.033-.012.022-.008a.517.517,0,0,0,.066-.051.625.625,0,0,0,.1-.076.541.541,0,0,0,.062-.1.578.578,0,0,0,.054-.1.616.616,0,0,0,.024-.122.556.556,0,0,0,.018-.075c0-.007,0-.012,0-.017a.564.564,0,0,0-.023-.114.531.531,0,0,0-.03-.11.152.152,0,0,0,0-.017l-.21-.42a.57.57,0,0,0,.271-.482A.578.578,0,0,0,16.164,29h-.595a.541.541,0,0,0-.116.024.569.569,0,0,0-.109.03h-.017a.517.517,0,0,0-.066.051.541.541,0,0,0-.1.076.492.492,0,0,0-.14.309.472.472,0,0,0-.026.092V29.6a.578.578,0,0,0,.023.114.531.531,0,0,0,.03.11.151.151,0,0,0,0,.017l.21.42a.569.569,0,0,0-.271.482Z",
    transform: "translate(-6.641 -11.876)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57784",
    "data-name": "Path 57784",
    d: "M8.607,38H8.6a.579.579,0,1,0,.006,0Z",
    transform: "translate(-3.7 -15.673)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57785",
    "data-name": "Path 57785",
    d: "M14.469,38H11.578a.578.578,0,1,0,0,1.156h2.891a.578.578,0,1,0,0-1.156Z",
    transform: "translate(-4.954 -15.673)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57786",
    "data-name": "Path 57786",
    d: "M8.607,35H8.6a.579.579,0,1,0,.006,0Z",
    transform: "translate(-3.7 -14.407)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57787",
    "data-name": "Path 57787",
    d: "M14.469,35H11.578a.578.578,0,1,0,0,1.156h2.891a.578.578,0,1,0,0-1.156Z",
    transform: "translate(-4.954 -14.407)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57788",
    "data-name": "Path 57788",
    d: "M9.446,44.891h2.891a1.446,1.446,0,0,0,0-2.891H9.446a1.446,1.446,0,0,0,0,2.891Zm2.891-1.735a.289.289,0,1,1,0,.578H9.446a.289.289,0,1,1,0-.578Z",
    transform: "translate(-3.687 -17.361)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57796",
    "data-name": "Path 57796",
    d: "M27.578,26.156h2.313a.578.578,0,0,0,0-1.156H27.578a.578.578,0,1,0,0,1.156Z",
    transform: "translate(-11.704 -10.187)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57797",
    "data-name": "Path 57797",
    d: "M34,25.734a.578.578,0,0,0,.578.578h.578a.572.572,0,0,0,.2-.041l.033-.012.022-.008a.517.517,0,0,0,.066-.051.625.625,0,0,0,.1-.076.541.541,0,0,0,.062-.1.531.531,0,0,0,.054-.1q.022-.1.042-.2v-.017a.564.564,0,0,0-.023-.114.531.531,0,0,0-.03-.11.15.15,0,0,0,0-.017l-.21-.42a.57.57,0,0,0,.271-.482A.578.578,0,0,0,35.164,24h-.6a.549.549,0,0,0-.113.022.579.579,0,0,0-.111.03h-.017a.517.517,0,0,0-.066.051.562.562,0,0,0-.1.076,1.355,1.355,0,0,0-.115.187.543.543,0,0,0-.025.122.535.535,0,0,0-.026.093V24.6a.578.578,0,0,0,.023.114.531.531,0,0,0,.03.11.153.153,0,0,0,0,.017l.21.42a.568.568,0,0,0-.263.478Z",
    transform: "translate(-14.657 -9.766)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57798",
    "data-name": "Path 57798",
    d: "M27.606,32.992H27.6a.579.579,0,1,0,.006,0Z",
    transform: "translate(-11.716 -13.561)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57799",
    "data-name": "Path 57799",
    d: "M33.469,32.992H30.578a.578.578,0,0,0,0,1.156h2.891a.578.578,0,0,0,0-1.156Z",
    transform: "translate(-12.97 -13.561)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57800",
    "data-name": "Path 57800",
    d: "M27.606,35.992H27.6a.579.579,0,1,0,.006,0Z",
    transform: "translate(-11.716 -14.827)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57801",
    "data-name": "Path 57801",
    d: "M33.469,35.992H30.578a.578.578,0,1,0,0,1.156h2.891a.578.578,0,0,0,0-1.156Z",
    transform: "translate(-12.97 -14.827)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57802",
    "data-name": "Path 57802",
    d: "M27.606,38.992H27.6a.578.578,0,1,0,.006,0Z",
    transform: "translate(-11.716 -16.093)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57803",
    "data-name": "Path 57803",
    d: "M33.469,38.992H30.578a.578.578,0,1,0,0,1.156h2.891a.578.578,0,0,0,0-1.156Z",
    transform: "translate(-12.97 -16.093)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57804",
    "data-name": "Path 57804",
    d: "M27.606,41.992H27.6a.578.578,0,1,0,.006,0Z",
    transform: "translate(-11.716 -17.358)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57805",
    "data-name": "Path 57805",
    d: "M33.469,41.992H30.578a.578.578,0,0,0,0,1.156h2.891a.578.578,0,0,0,0-1.156Z",
    transform: "translate(-12.97 -17.358)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57806",
    "data-name": "Path 57806",
    d: "M27.606,29.992H27.6a.578.578,0,1,0,.006,0Z",
    transform: "translate(-11.716 -12.296)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57807",
    "data-name": "Path 57807",
    d: "M33.469,29.992H30.578a.578.578,0,1,0,0,1.156h2.891a.578.578,0,0,0,0-1.156Z",
    transform: "translate(-12.97 -12.296)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57808",
    "data-name": "Path 57808",
    d: "M28.446,49.891h2.891a1.446,1.446,0,1,0,0-2.891H28.446a1.446,1.446,0,0,0,0,2.891Zm2.891-1.735a.289.289,0,1,1,0,.578H28.446a.289.289,0,0,1,0-.578Z",
    transform: "translate(-11.704 -19.472)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup9219);
export default __webpack_public_path__ + "static/media/Group 9219.9e7e467ae6c94c35d96a2a6dac7eead3.svg";
export { ForwardRef as ReactComponent };